import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import Logo from '../components/Logo';
import Seo from '../components/Seo';

const GOLD = '#C0975C';
const IVORY = '#F5F1E8';
const heading = { fontFamily: "'Outfit', sans-serif" };

export default function NotFound() {
  return (
    <main className="min-h-screen flex items-center justify-center px-6" style={{ backgroundColor: '#061530', color: IVORY }} data-testid="not-found-page">
      <Seo
        title="Page not found — Precision Wealth"
        description="The page you are looking for could not be found. Return to Precision Wealth to keep learning."
        path="/404"
        noindex
      />
      <div className="absolute top-8 left-8"><Link to="/" aria-label="Precision Wealth home"><Logo variant="light" size="md" layout="horizontal" /></Link></div>
      <div className="max-w-lg text-center">
        <div className="text-[7rem] leading-none font-extrabold text-gradient-gold" style={heading}>404</div>
        <h1 className="text-3xl md:text-4xl font-bold mt-2 mb-4" style={heading}>This page took a wrong turn.</h1>
        <p className="text-[15px] leading-relaxed mb-8" style={{ color: '#94A9C9' }}>
          The page you are looking for does not exist or may have moved. Let us get you back on track.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/" data-testid="notfound-home-btn" className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full font-semibold transition-all hover:opacity-90" style={{ backgroundColor: GOLD, color: '#0A1F44' }}>
            <Home className="w-4 h-4" /> Back to home
          </Link>
          <Link to="/auth?mode=signup" className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full font-semibold transition-all hover:bg-white/5" style={{ border: '1px solid rgba(245,241,232,0.35)', color: IVORY }}>
            <ArrowLeft className="w-4 h-4" /> Start learning
          </Link>
        </div>
      </div>
    </main>
  );
}
